<button type="button" class="mu_chat_launcher" [attr.aria-label]="'shared.chatLauncherLabel' | translate" (click)="pressed.emit()">
  <svg class="mu_chat_launcher__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M12 3.5c-4.7 0-8.5 3.4-8.5 7.6 0 1.8.7 3.5 1.9 4.8L4.5 20l4.4-1.6c1 .4 2 .5 3.1.5 4.7 0 8.5-3.4 8.5-7.6S16.7 3.5 12 3.5Z" />
  </svg>
</button>
